import React, { useCallback } from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import type { PromoPage as PromoPageData } from 'api/api.types'
import { setAppointmentSalon } from 'src/store/appointment.store'
import { parseHtml } from 'utils/htmlParserWithCustomLinks'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { Salons } from 'components/PageElements/Salons/Salons'
import { Picture } from 'components/Utility/Media/Picture'
import styles from './PromoPage.module.scss'

type PromoPageProps = {
  page: PromoPageData,
}

/** A landing page for one salon's promotion, hidden from search engines */
export const PromoPage: React.FC<PromoPageProps> = ({ page }) => {
  const vars = page.templateVars.pageVars
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const salonId = vars.salon?.id

  const handleAppointmentClick = useCallback(() => {
    dispatch(setAppointmentSalon(Number(salonId)))
    navigate('#appointment')
  }, [dispatch, salonId, navigate])

  return <div className={styles.container}>
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <div className={styles.contentContainer}>
      <div className={styles.textContainer}>
        <div className={styles.content}>
          <h1 className={styles.title}>{page.title}</h1>
          <article className={'text-content'}>{parseHtml(vars.content || '')}</article>
        </div>
        <div className={styles.imageContainer}>
          {vars.image && (
            <Picture
              className={styles.img}
              image={vars.image.image}
              desktopType={'fullscreen-desktop'}
              mobileType={'fullscreen-mobile'}
              alt={vars.image.type === 'image' ? vars.image.imageAlt : undefined}
            />
          )}
        </div>
      </div>
      <div className={styles.links}>
        <AppButton className={styles.MobileBtns} onClick={handleAppointmentClick}>Записаться</AppButton>
        <a href={`tel:+${vars.salon?.phone}`} target={'_blank'} rel="noopener noreferrer">
          <AppButton className={styles.MobileBtns}>Позвонить</AppButton>
        </a>
      </div>
    </div>
    <div className={styles.map}>
      <Salons withCityTitle />
    </div>
  </div>
}
